import { XMarkIcon } from "@heroicons/react/24/outline";
import {
  IAvailableEndpoint,
  IMcpToolUpdate
} from "../../interfaces/endpoints/IMcpTool";
import McpToolForm from "./McpToolForm";

interface Props {
  form: IMcpToolUpdate;
  setForm: React.Dispatch<React.SetStateAction<IMcpToolUpdate>>;
  isEdit: boolean;
  saving: boolean;
  endpoints: IAvailableEndpoint[];
  onChange: (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => void;
  onEndpointSelect: (ep: IAvailableEndpoint) => void;
  onSubmit: (e: React.FormEvent) => void;
  onClose: () => void;
}

const McpToolModalContent: React.FC<Props> = ({
  form, setForm, isEdit, saving,
  endpoints, onChange, onEndpointSelect,
  onSubmit, onClose
}) => (
  <div className="bg-white rounded-lg w-full max-w-2xl
    max-h-[90vh] overflow-y-auto mx-4"
  >
    <div className="flex items-center justify-between p-4 border-b">
      <h2 className="text-lg font-semibold">
        {isEdit ? "Edit MCP Tool" : "Add New MCP Tool"}
      </h2>
      <button
        onClick={onClose}
        className="p-1 hover:bg-gray-100 rounded"
      >
        <XMarkIcon className="w-5 h-5" />
      </button>
    </div>
    <form onSubmit={onSubmit} className="p-4">
      <McpToolForm
        form={form}
        onChange={onChange}
        setForm={setForm}
        endpoints={endpoints}
        onEndpointSelect={onEndpointSelect}
        isEdit={isEdit}
      />
      <div className="flex justify-end gap-2 pt-4 mt-4 border-t">
        <button
          type="button" onClick={onClose}
          className="px-4 py-2 text-sm border rounded-md
            hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit" disabled={saving}
          className="px-4 py-2 text-sm bg-primary text-white
            rounded-md disabled:opacity-50"
        >
          {saving ? "Saving..." : isEdit
            ? "Save Changes"
            : "Create Tool"}
        </button>
      </div>
    </form>
  </div>
);

export default McpToolModalContent;
